import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import PledgePage from "@/pages/PledgePage";
import LiveWallPage from "@/pages/LiveWallPage";
import RetrievePage from "@/pages/RetrievePage";
import MomentLookupPage from "@/pages/MomentLookupPage";
import MrLookupPage from "@/pages/MrLookupPage";
import MomentReplayPage from "@/pages/MomentReplayPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import MrLoginPage from "@/pages/MrLoginPage";
import MrPledgesPage from "@/pages/MrPledgesPage";
import MrSelfPledgePage from "@/pages/MrSelfPledgePage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminPledgesPage from "@/pages/AdminPledgesPage";
import AdminMrsPage from "@/pages/AdminMrsPage";
import AdminMrDetailPage from "@/pages/AdminMrDetailPage";
import AdminLinksPage from "@/pages/AdminLinksPage";
import AdminReportsPage from "@/pages/AdminReportsPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pledge" element={<PledgePage />} />
          {/* unlisted named pledge links (/pledge/self, /pledge/manoj, …) —
              registered in the admin panel, intentionally not linked in the UI */}
          <Route path="/pledge/:linkName" element={<PledgePage selfService />} />
          <Route path="/wall" element={<LiveWallPage />} />
          <Route path="/live-team-pledge" element={<LiveWallPage team />} />
          <Route path="/retrieve" element={<RetrievePage />} />
          <Route path="/my-moment" element={<MomentLookupPage />} />
          <Route path="/my-moment/:certId" element={<MomentReplayPage />} />
          {/* public, no-login Emp Code lookup for the field team */}
          <Route path="/mr-lookup" element={<MrLookupPage />} />
          <Route path="/mr/login" element={<MrLoginPage />} />
          <Route path="/mr/pledges" element={<MrPledgesPage />} />
          <Route path="/mr/self-pledge" element={<MrSelfPledgePage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/pledges" element={<AdminPledgesPage />} />
          <Route path="/admin/mrs" element={<AdminMrsPage />} />
          <Route path="/admin/mrs/:empCode" element={<AdminMrDetailPage />} />
          <Route path="/admin/links" element={<AdminLinksPage />} />
          <Route path="/admin/reports" element={<AdminReportsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
